import { TableConfig } from '../../../../components/table/Table';

export const initAuftragsvorlageManagementTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Name',
      attributName: 'name',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Mandant',
      attributName: 'mandant',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Frankatur',
      attributName: 'frankatur',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Verkehrsart',
      attributName: 'verkehrsart',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Empfänger',
      attributName: 'empfaenger',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'Terminart',
      attributName: 'terminart',
      valueType: 'string',
    },
    {
      id: 7,
      columnName: 'Klassifizierug',
      attributName: 'klassifizierung',
      valueType: 'string',
    },
  ];
};
